<template>
  <div class="body">
    <div class="title">
      查看详情
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>通讯录管理</el-breadcrumb-item>
          <el-breadcrumb-item>名片管理</el-breadcrumb-item>
          <el-breadcrumb-item>查看详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="基本信息" name="first">
        <el-card  class="cardpsad">
          <el-row>
            <el-col :span="12">
              <div class="fromdsadas">
                <div class="tiile">
                  基本资料
                </div>
                <div>
                  <el-form class="demo-form-inline" :label-position="labelPosition">
                    <el-form-item label="姓名" label-width="116px">
                      任秀兰
                    </el-form-item>
                    <el-form-item label="头像" label-width="116px">
                      <img src="../../assets/img/logo.png" alt="">
                    </el-form-item>
                    <el-form-item label="性别" label-width="116px">
                      女
                    </el-form-item>
                    <el-form-item label="手机号码" label-width="116px">
                      手机号码
                    </el-form-item>
                    <el-form-item label="微信号" label-width="116px">
                      微信号
                    </el-form-item>
                    <el-form-item label="家乡" label-width="116px">
                      <div class="wenbenyu">
                        家乡人员之间的交流与合作，为会员服务，维护会员合法权益。
                      </div>
                    </el-form-item>
                    <el-form-item label="是否单身" label-width="116px">
                      是否单身
                    </el-form-item>
                    <el-form-item label="社会职务 " label-width="116px">
                      社会职务
                    </el-form-item>
                    <el-form-item label="喜好" label-width="116px">
                      喜好
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="fromdsadas">
                <div class="tiile">
                  会员信息
                </div>
                <el-form class="demo-form-inline" :label-position="labelPosition">
                  <el-form-item label="会员状态 " label-width="116px">
                    会员状态
                  </el-form-item>
                  <el-form-item label="置顶状态" label-width="116px">
                    置顶状态
                  </el-form-item>
                  <el-form-item label="名片状态" label-width="116px">
                    名片状态
                  </el-form-item>
                  <el-form-item label="浏览人次" label-width="116px">
                    浏览人次
                  </el-form-item>
                  <el-form-item label="关注者" label-width="116px">
                    关注者
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="生意信息" name="second">
        <el-row>
          <el-col :span="12">
            <div class="fromdsadas">
              <div>
                <el-form class="demo-form-inline" :label-position="labelPosition">
                  <el-form-item label="企业名称" label-width="116px">
                    企业名称
                  </el-form-item>
                  <el-form-item label="企业地址" label-width="116px">
                    企业地址
                  </el-form-item>
                  <el-form-item label="企业所属行业" label-width="116px">
                    企业所属行业
                  </el-form-item>
                  <el-form-item label="身份" label-width="116px">
                    身份
                  </el-form-item>
                  <el-form-item label="公司宣传图片" label-width="116px">
                    微信号
                  </el-form-item>
                  <el-form-item label="家乡" label-width="116px">
                    <div class="wenbenyu">
                      家乡人员之间的交流与合作，为会员服务，维护会员合法权益。
                    </div>
                  </el-form-item>
                  <el-form-item label="公司宣传商品" label-width="116px">
                    是否单身
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="供应信息" name="third">
        <el-row>
          <el-col :span="12">
            <div class="fromdsadas">
              <div>
                <el-form class="demo-form-inline" :label-position="labelPosition">
                  <el-form-item label="供需标题" label-width="116px">
                    企业名称
                  </el-form-item>
                  <el-form-item label="供需介绍" label-width="116px">
                    企业地址
                  </el-form-item>
                  <el-form-item label="供需图片" label-width="116px">
                    企业所属行业
                  </el-form-item>
                  <el-form-item label="联系电话" label-width="116px">
                    身份
                  </el-form-item>
                  <el-form-item label="发布时间" label-width="116px">
                    微信号
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="需求信息" name="fourth">
        <el-row>
          <el-col :span="12">
            <div class="fromdsadas">
              <div>
                <el-form class="demo-form-inline" :label-position="labelPosition">
                  <el-form-item label="供需标题" label-width="116px">
                    企业名称
                  </el-form-item>
                  <el-form-item label="供需介绍" label-width="116px">
                    企业地址
                  </el-form-item>
                  <el-form-item label="供需图片" label-width="116px">
                    企业所属行业
                  </el-form-item>
                  <el-form-item label="联系电话" label-width="116px">
                    身份
                  </el-form-item>
                  <el-form-item label="发布时间" label-width="116px">
                    微信号
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      activeName: 'first',
      labelPosition: 'left'
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="less">
.body {
  display: flex;
  flex-direction: column;

  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3D9AFF;
    }
  }

  .btnsearch {
    display: flex;
    flex-direction: row;
    align-items: center;

    .left {
      flex: 1;
      margin-right: 150px;

      .btn {
        width: 124px;
        height: 43px;
        opacity: 1;
        background: linear-gradient(135deg, #1bb745, #17ab3f);
        border-radius: 5px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        letter-spacing: 0px;
        border: none;
        background: white;
      }
    }

    .right {
      margin-top: 27px;
    }
  }
  .cardpsad{
    padding:40px 50px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    .fromdsadas{
      display:flex;
      flex-direction: column;
      .tiile{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        text-align: left;
        color: #2e2e2e;
        letter-spacing: 0px;
        margin-bottom: 42px;
      }
    }
  }
}
</style>
